import type { AxiosInstance } from 'axios'

export const addBaseInterceptors = (_interceptors: AxiosInstance['interceptors']) => {
	// interceptors.request.use(async (config) => await addLogsToRequests(config))
}
